import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SiteTreeIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SiteTree",
    children: /*#__PURE__*/_jsx("path", {
      d: "M19.03 17.68h-8.3v7.84h8.3c0-1.24 1-2.24 2.24-2.24h2.24c1.24 0 2.24 1 2.24 2.24v2.24c0 1.24-1 2.24-2.24 2.24h-2.24c-1.24 0-2.24-1-2.24-2.24H9.61c-.62 0-1.12-.5-1.12-1.12V8.72c-1.24 0-2.24-1-2.24-2.24V4.24C6.25 3 7.25 2 8.49 2h2.24c1.24 0 2.24 1 2.24 2.24v2.24c0 1.24-1 2.24-2.24 2.24v6.72h8.3c0-1.24 1-2.24 2.24-2.24h2.24c1.24 0 2.24 1 2.24 2.24v2.24c0 1.24-1 2.24-2.24 2.24h-2.24c-1.24 0-2.24-1-2.24-2.24"
    })
  }));
};